import { ColumnHelper } from "PFComponents/table/table.types";
import { Typography } from "PFComponents/typography";
import { Activity } from "PFTypes";

import { MatchesTableEntry } from "../../../../hooks/use_resource_matches";
import { WorkforceMemberCell } from "./workforce_member_cell";

type CreateWorkforceMemberColumnArgs = {
  headerLabel: string;
  activity: Activity;
  size?: number;
};

export const createWorkforceMemberColumn = (
  columnHelper: ColumnHelper<MatchesTableEntry>,
  { headerLabel, activity, size }: CreateWorkforceMemberColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id: "workforceMember",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <WorkforceMemberCell profile={info.getValue().profile} activity={activity} />,
    enableSorting: false,
    size
  });
